import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  JSON: { [key: string]: any };
};

export type ActionResult = {
  __typename?: 'ActionResult';
  success: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export type Assignment = {
  __typename?: 'Assignment';
  id: Scalars['ID'];
  collection?: Maybe<Collection>;
  title: Scalars['String'];
  evaluations: Array<Evaluation>;
  assignees: Array<Maybe<Principal>>;
  rounds: Array<Maybe<AssignmentRound>>;
  evaluationType: EvaluationType;
  defaultEvaluationParameters?: Maybe<EvaluationParameters>;
  availableStartDate?: Maybe<Scalars['Date']>;
  availableEndDate?: Maybe<Scalars['Date']>;
  status: AssignmentStatus;
  assignedToMe: Scalars['Boolean'];
  numRounds: Scalars['Int'];
  created?: Maybe<AuditRecord>;
  updated?: Maybe<AuditRecord>;
};


export type AssignmentEvaluationsArgs = {
  mineOnly?: Maybe<Scalars['Boolean']>;
};

export type AssignmentRound = {
  __typename?: 'AssignmentRound';
  key: Scalars['ID'];
  index: Scalars['Int'];
  post: Post;
  evaluationParameters?: Maybe<EvaluationParameters>;
};

export enum AssignmentStatus {
  Pending = 'PENDING',
  Available = 'AVAILABLE',
  Expired = 'EXPIRED'
}

export type AuditRecord = {
  __typename?: 'AuditRecord';
  date?: Maybe<Scalars['Date']>;
  user?: Maybe<User>;
};

export type Collection = {
  __typename?: 'Collection';
  id: Scalars['String'];
  name: Scalars['String'];
  userRoles?: Maybe<Array<Maybe<UserRole>>>;
  post?: Maybe<Post>;
  postByAttribute?: Maybe<Post>;
  posts?: Maybe<PostPage>;
  playlists?: Maybe<PlaylistPage>;
  /** gets assignments in this collection; defaults to mineOnly but admins can set that False to see all */
  assignments: Array<Assignment>;
  getAssignment?: Maybe<Assignment>;
  getEvaluation?: Maybe<Evaluation>;
  evaluations: Array<Evaluation>;
  unlisted?: Maybe<Scalars['Boolean']>;
  groups?: Maybe<Array<Maybe<Group>>>;
  postManifestSource?: Maybe<Scalars['String']>;
  myRoles: Array<Role>;
  getPlaylist?: Maybe<Playlist>;
  findUser?: Maybe<User>;
};


export type CollectionPostArgs = {
  post_id?: Maybe<Scalars['String']>;
};


export type CollectionPostByAttributeArgs = {
  attributeName: Scalars['String'];
  value: Scalars['String'];
};


export type CollectionPostsArgs = {
  limit?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  searchString?: Maybe<Scalars['String']>;
};


export type CollectionPlaylistsArgs = {
  limit?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  searchString?: Maybe<Scalars['String']>;
};


export type CollectionAssignmentsArgs = {
  mineOnly?: Maybe<Scalars['Boolean']>;
};


export type CollectionGetAssignmentArgs = {
  assignment_id: Scalars['ID'];
};


export type CollectionGetEvaluationArgs = {
  evaluation_id: Scalars['ID'];
};


export type CollectionEvaluationsArgs = {
  mineOnly?: Maybe<Scalars['Boolean']>;
};


export type CollectionGetPlaylistArgs = {
  playlist_id: Scalars['String'];
};


export type CollectionFindUserArgs = {
  userName: Scalars['String'];
};

export type CollectionGroupInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  users: Array<Maybe<GroupUserInput>>;
  collection_id?: Maybe<Scalars['String']>;
};

export type CollectionInput = {
  name: Scalars['String'];
  posts?: Maybe<Array<Maybe<PostRefInput>>>;
  userRoles?: Maybe<Array<Maybe<UserRoleInput>>>;
  groups?: Maybe<Array<Maybe<CollectionGroupInput>>>;
  unlisted?: Maybe<Scalars['Boolean']>;
};

export type Evaluation = {
  __typename?: 'Evaluation';
  id: Scalars['ID'];
  author?: Maybe<User>;
  evaluationType: EvaluationType;
  parameters?: Maybe<EvaluationParameters>;
  status: EvaluationStatus;
  created?: Maybe<AuditRecord>;
  updated?: Maybe<AuditRecord>;
  session?: Maybe<EvaluationSession>;
};

export type EvaluationParameters = {
  __typename?: 'EvaluationParameters';
  values?: Maybe<Scalars['JSON']>;
};

/** A session where a person or algorithm evaluates zero or more Posts, with one specified EvaluationType */
export type EvaluationSession = {
  __typename?: 'EvaluationSession';
  id: Scalars['ID'];
  collection?: Maybe<Collection>;
  sourceAssignment?: Maybe<Assignment>;
  evaluationType: EvaluationType;
  defaultEvaluationParameters?: Maybe<EvaluationParameters>;
  type: EvaluationType;
  owner?: Maybe<Principal>;
  created?: Maybe<AuditRecord>;
  updated?: Maybe<AuditRecord>;
};

export enum EvaluationSessionStatus {
  Draft = 'DRAFT',
  Ready = 'READY',
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED'
}

export enum EvaluationStatus {
  Draft = 'DRAFT',
  Complete = 'COMPLETE',
  Cancelled = 'CANCELLED'
}

export type EvaluationType = {
  __typename?: 'EvaluationType';
  key: Scalars['ID'];
  name: Scalars['String'];
};

export type Group = {
  __typename?: 'Group';
  id: Scalars['String'];
  name: Scalars['String'];
  users: Array<Maybe<User>>;
  collection_id?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
};

export type GroupUserInput = {
  id?: Maybe<Scalars['String']>;
};

export type ImageFile = MediaFile & {
  __typename?: 'ImageFile';
  key: Scalars['String'];
  tags: Array<Maybe<MediaTags>>;
  defaultFormat: ImageFileFormat;
  formats: Array<ImageFileFormat>;
  format?: Maybe<ImageFileFormat>;
  findFormat: ImageFileFormat;
  created?: Maybe<AuditRecord>;
  updated?: Maybe<AuditRecord>;
};


export type ImageFileFormatArgs = {
  format_key: Scalars['String'];
};


export type ImageFileFindFormatArgs = {
  preferredWidth?: Maybe<Scalars['Int']>;
  preferredHeight?: Maybe<Scalars['Int']>;
};

export type ImageFileFormat = MediaFileFormat & {
  __typename?: 'ImageFileFormat';
  key: Scalars['String'];
  sourceUrl: Scalars['String'];
  downloadUrl?: Maybe<Scalars['String']>;
  contentType: Scalars['String'];
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  default?: Maybe<Scalars['Boolean']>;
};

export type ImageFormatInfoInput = {
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
};

export type MediaFile = {
  key: Scalars['String'];
  tags: Array<Maybe<MediaTags>>;
  defaultFormat?: Maybe<MediaFileFormat>;
  format?: Maybe<MediaFileFormat>;
  formats: Array<MediaFileFormat>;
  created?: Maybe<AuditRecord>;
  updated?: Maybe<AuditRecord>;
};


export type MediaFileFormatArgs = {
  format_key: Scalars['String'];
};

export type MediaFileFormat = {
  key: Scalars['String'];
  sourceUrl: Scalars['String'];
  downloadUrl?: Maybe<Scalars['String']>;
  contentType: Scalars['String'];
  default?: Maybe<Scalars['Boolean']>;
};

export enum MediaTags {
  PrimaryVideo = 'PrimaryVideo',
  PrimaryPoster = 'PrimaryPoster'
}

export type MediaUploadInfo = {
  __typename?: 'MediaUploadInfo';
  uploadUri: Scalars['String'];
  uploadKey: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  createPost?: Maybe<Post>;
  updatePost?: Maybe<Post>;
  startPostMediaUpload?: Maybe<MediaUploadInfo>;
  completePostMediaUpload?: Maybe<PostMediaUploadResult>;
  createCollection?: Maybe<Collection>;
  updateCollection?: Maybe<Collection>;
  loadManifestUrl?: Maybe<ActionResult>;
  deleteMediaFile?: Maybe<Post>;
  createPlaylist?: Maybe<Playlist>;
  updatePlaylist?: Maybe<Playlist>;
  requestTranscodePostVideo?: Maybe<Scalars['String']>;
  createPlaceholderUser: User;
  /** Evaluations */
  createEvaluation?: Maybe<Evaluation>;
  createPostAccessToken: Scalars['String'];
};


export type MutationCreatePostArgs = {
  collection_id: Scalars['String'];
  owner_principal_id?: Maybe<Scalars['String']>;
};


export type MutationUpdatePostArgs = {
  id?: Maybe<Scalars['String']>;
  input?: Maybe<PostInput>;
};


export type MutationStartPostMediaUploadArgs = {
  post_id: Scalars['String'];
  contentType: Scalars['String'];
  mediaFileKey?: Maybe<Scalars['String']>;
  makeDefault?: Maybe<Scalars['Boolean']>;
  tags?: Maybe<Array<Maybe<MediaTags>>>;
  imageFormatInfo?: Maybe<ImageFormatInfoInput>;
  videoFormatInfo?: Maybe<VideoFormatInfoInput>;
};


export type MutationCompletePostMediaUploadArgs = {
  uploadKey?: Maybe<Scalars['String']>;
};


export type MutationCreateCollectionArgs = {
  input?: Maybe<CollectionInput>;
};


export type MutationUpdateCollectionArgs = {
  collection_id: Scalars['String'];
  input?: Maybe<CollectionInput>;
};


export type MutationLoadManifestUrlArgs = {
  collection_id: Scalars['String'];
  mainfest_url?: Maybe<Scalars['String']>;
};


export type MutationDeleteMediaFileArgs = {
  post_id: Scalars['String'];
  mediaFileKey: Scalars['String'];
};


export type MutationCreatePlaylistArgs = {
  collection_id: Scalars['String'];
  input: PlaylistCreateInput;
};


export type MutationUpdatePlaylistArgs = {
  playlist_id: Scalars['String'];
  input?: Maybe<PlaylistUpdateInput>;
};


export type MutationRequestTranscodePostVideoArgs = {
  collection_id: Scalars['String'];
  post_id: Scalars['String'];
  source_mediaFile_key?: Maybe<Scalars['String']>;
  source_mediaFormat_key?: Maybe<Scalars['String']>;
  makeDefault?: Maybe<Scalars['Boolean']>;
};


export type MutationCreatePlaceholderUserArgs = {
  collection_id: Scalars['String'];
  userName: Scalars['String'];
};


export type MutationCreateEvaluationArgs = {
  collection_id: Scalars['String'];
  post_id: Scalars['String'];
  evaluationType_id: Scalars['String'];
};


export type MutationCreatePostAccessTokenArgs = {
  collection_id: Scalars['String'];
  post_id: Scalars['String'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor: Scalars['String'];
  endCursor: Scalars['String'];
};

export type Playlist = {
  __typename?: 'Playlist';
  id: Scalars['String'];
  title: Scalars['String'];
  collection: Collection;
  posts?: Maybe<Array<PlaylistPostEntry>>;
  getPostByIndex?: Maybe<PlaylistPostEntry>;
  numPosts?: Maybe<Scalars['Int']>;
  roleGrants?: Maybe<Array<Maybe<UserRole>>>;
  created?: Maybe<AuditRecord>;
  updated?: Maybe<AuditRecord>;
  sourceId?: Maybe<Scalars['String']>;
  myRoles: Array<Role>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  isAvailableMe?: Maybe<Scalars['Boolean']>;
  availableStartDate?: Maybe<Scalars['Date']>;
  availableEndDate?: Maybe<Scalars['Date']>;
};


export type PlaylistGetPostByIndexArgs = {
  post_index: Scalars['Int'];
};

export type PlaylistCreateInput = {
  title: Scalars['String'];
  post_ids: Array<Scalars['String']>;
};

export type PlaylistEdge = {
  __typename?: 'PlaylistEdge';
  cursor: Scalars['String'];
  node: Playlist;
};

export type PlaylistPage = {
  __typename?: 'PlaylistPage';
  pageInfo: PageInfo;
  edges: Array<Maybe<PlaylistEdge>>;
};

export type PlaylistPostEntry = {
  __typename?: 'PlaylistPostEntry';
  index: Scalars['Int'];
  post: Post;
  next_index?: Maybe<Scalars['Int']>;
  prev_index?: Maybe<Scalars['Int']>;
};

export type PlaylistUpdateInput = {
  title?: Maybe<Scalars['String']>;
  post_ids?: Maybe<Array<Scalars['String']>>;
  roleGrants?: Maybe<Array<Maybe<UserRoleInput>>>;
};

export type Post = {
  __typename?: 'Post';
  id: Scalars['String'];
  title: Scalars['String'];
  collection: Collection;
  primaryVideo?: Maybe<VideoFile>;
  primaryPoster?: Maybe<ImageFile>;
  mediaFiles: Array<MediaFile>;
  mediaFile?: Maybe<MediaFile>;
  owner?: Maybe<Principal>;
  roleGrants?: Maybe<Array<Maybe<UserRole>>>;
  created?: Maybe<AuditRecord>;
  updated?: Maybe<AuditRecord>;
  sourceId?: Maybe<Scalars['String']>;
  myRoles: Array<Role>;
  deleted?: Maybe<Scalars['Boolean']>;
  evaluations: Array<Maybe<Evaluation>>;
};


export type PostMediaFileArgs = {
  mediafile_key: Scalars['String'];
};

export type PostEdge = {
  __typename?: 'PostEdge';
  cursor: Scalars['String'];
  node: Post;
};

export type PostInput = {
  title: Scalars['String'];
  roleGrants?: Maybe<Array<Maybe<UserRoleInput>>>;
};

export type PostMediaUploadResult = {
  __typename?: 'PostMediaUploadResult';
  post: Post;
  mediaFileKey: Scalars['String'];
  mediaFileFormatKey: Scalars['String'];
  sourceUrl: Scalars['String'];
  contentType: Scalars['String'];
};

export type PostPage = {
  __typename?: 'PostPage';
  pageInfo: PageInfo;
  edges: Array<Maybe<PostEdge>>;
};

export type PostRefInput = {
  post_id: Scalars['String'];
};

export type Principal = User | Group | UserCategoryMember;

export type Query = {
  __typename?: 'Query';
  me?: Maybe<User>;
  myRoles: Array<Role>;
  getCollections: Array<Maybe<Collection>>;
  getCollection?: Maybe<Collection>;
  getGroups: Array<Maybe<Group>>;
  evaluationTypes: Array<Maybe<EvaluationType>>;
  evaluationType?: Maybe<EvaluationType>;
};


export type QueryGetCollectionArgs = {
  collection_id: Scalars['String'];
};


export type QueryEvaluationTypeArgs = {
  evaluationType_key: Scalars['String'];
};

export enum Role {
  Admin = 'ADMIN',
  Editor = 'EDITOR',
  Creator = 'CREATOR',
  Reader = 'READER',
  MediaManager = 'MEDIA_MANAGER',
  Viewer = 'VIEWER'
}

export type User = {
  __typename?: 'User';
  id: Scalars['String'];
  userName: Scalars['String'];
  givenName?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  objectID: Scalars['String'];
  ownedPosts?: Maybe<Array<Maybe<Post>>>;
  globalRoles?: Maybe<Array<Maybe<Role>>>;
  groups: Array<Maybe<Group>>;
};

export enum UserCategory {
  Everyone = 'EVERYONE',
  Authenticated = 'AUTHENTICATED'
}

export type UserCategoryMember = {
  __typename?: 'UserCategoryMember';
  userCategory: UserCategory;
};

export type UserRole = {
  __typename?: 'UserRole';
  principal: Principal;
  role: Role;
};

export type UserRoleInput = {
  principal_id: Scalars['String'];
  role: Scalars['String'];
};

export type VideoFile = MediaFile & {
  __typename?: 'VideoFile';
  key: Scalars['String'];
  tags: Array<Maybe<MediaTags>>;
  lengthMs?: Maybe<Scalars['Int']>;
  defaultFormat: VideoFileFormat;
  formats: Array<VideoFileFormat>;
  format?: Maybe<VideoFileFormat>;
  created?: Maybe<AuditRecord>;
  updated?: Maybe<AuditRecord>;
};


export type VideoFileFormatArgs = {
  format_key: Scalars['String'];
};

export type VideoFileFormat = MediaFileFormat & {
  __typename?: 'VideoFileFormat';
  key: Scalars['String'];
  sourceUrl: Scalars['String'];
  downloadUrl?: Maybe<Scalars['String']>;
  contentType: Scalars['String'];
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  frameRate?: Maybe<Scalars['Int']>;
  default?: Maybe<Scalars['Boolean']>;
};

export type VideoFormatInfoInput = {
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
};

export type AssignmentCard_AssignmentFragment = { __typename?: 'Assignment', id: string, title: string, status: AssignmentStatus, assignedToMe: boolean, availableStartDate?: Maybe<any>, availableEndDate?: Maybe<any>, numRounds: number };

export type AssignmentTable_AssignmentFragment = { __typename?: 'Assignment', id: string, title: string, status: AssignmentStatus, assignedToMe: boolean, availableStartDate?: Maybe<any>, availableEndDate?: Maybe<any>, numRounds: number };

export type AssignmentList_AssignmentFragment = { __typename?: 'Assignment', id: string, title: string, status: AssignmentStatus, assignedToMe: boolean, availableStartDate?: Maybe<any>, availableEndDate?: Maybe<any>, numRounds: number };

export type AssignmentList_CollectionFragment = { __typename?: 'Collection', id: string, name: string, myRoles: Array<Role> };

export type AssignmentList_BaseQueryVariables = Exact<{
  collection_id: Scalars['String'];
}>;


export type AssignmentList_BaseQuery = { __typename?: 'Query', getCollection?: Maybe<{ __typename?: 'Collection', id: string, name: string, myRoles: Array<Role>, assignments: Array<{ __typename?: 'Assignment', id: string, title: string, status: AssignmentStatus, assignedToMe: boolean, availableStartDate?: Maybe<any>, availableEndDate?: Maybe<any>, numRounds: number }> }>, me?: Maybe<{ __typename?: 'User', id: string, userName: string, displayName?: Maybe<string>, globalRoles?: Maybe<Array<Maybe<Role>>> }> };

export type EditCollCollFragment = { __typename?: 'Collection', id: string, name: string, unlisted?: Maybe<boolean>, myRoles: Array<Role>, userRoles?: Maybe<Array<Maybe<{ __typename?: 'UserRole', role: Role, principal: { __typename: 'User', id: string, userName: string, givenName?: Maybe<string>, familyName?: Maybe<string>, displayName?: Maybe<string> } | { __typename: 'Group', id: string, name: string } | { __typename: 'UserCategoryMember', userCategory: UserCategory } }>>>, groups?: Maybe<Array<Maybe<{ __typename: 'Group', id: string, name: string, users: Array<Maybe<{ __typename?: 'User', id: string, userName: string, givenName?: Maybe<string>, familyName?: Maybe<string>, displayName?: Maybe<string> }>> }>>> };

export type EditCollgetCollQueryVariables = Exact<{
  collection_id: Scalars['String'];
}>;


export type EditCollgetCollQuery = { __typename?: 'Query', getCollection?: Maybe<{ __typename?: 'Collection', id: string, name: string, unlisted?: Maybe<boolean>, myRoles: Array<Role>, userRoles?: Maybe<Array<Maybe<{ __typename?: 'UserRole', role: Role, principal: { __typename: 'User', id: string, userName: string, givenName?: Maybe<string>, familyName?: Maybe<string>, displayName?: Maybe<string> } | { __typename: 'Group', id: string, name: string } | { __typename: 'UserCategoryMember', userCategory: UserCategory } }>>>, groups?: Maybe<Array<Maybe<{ __typename: 'Group', id: string, name: string, users: Array<Maybe<{ __typename?: 'User', id: string, userName: string, givenName?: Maybe<string>, familyName?: Maybe<string>, displayName?: Maybe<string> }>> }>>> }>, me?: Maybe<{ __typename?: 'User', id: string, userName: string, displayName?: Maybe<string>, globalRoles?: Maybe<Array<Maybe<Role>>> }> };

export type EditCollUpdateCollMutationVariables = Exact<{
  collection_id: Scalars['String'];
  inp?: Maybe<CollectionInput>;
}>;


export type EditCollUpdateCollMutation = { __typename?: 'Mutation', updateCollection?: Maybe<{ __typename?: 'Collection', id: string, name: string, unlisted?: Maybe<boolean>, myRoles: Array<Role>, userRoles?: Maybe<Array<Maybe<{ __typename?: 'UserRole', role: Role, principal: { __typename: 'User', id: string, userName: string, givenName?: Maybe<string>, familyName?: Maybe<string>, displayName?: Maybe<string> } | { __typename: 'Group', id: string, name: string } | { __typename: 'UserCategoryMember', userCategory: UserCategory } }>>>, groups?: Maybe<Array<Maybe<{ __typename: 'Group', id: string, name: string, users: Array<Maybe<{ __typename?: 'User', id: string, userName: string, givenName?: Maybe<string>, familyName?: Maybe<string>, displayName?: Maybe<string> }>> }>>> }> };

export type GetCollectionsListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCollectionsListQuery = { __typename?: 'Query', myRoles: Array<Role>, getCollections: Array<Maybe<{ __typename?: 'Collection', id: string, name: string, myRoles: Array<Role> }>>, me?: Maybe<{ __typename?: 'User', id: string, userName: string, displayName?: Maybe<string>, globalRoles?: Maybe<Array<Maybe<Role>>> }> };

export type CollectionCreate_BaseQueryVariables = Exact<{ [key: string]: never; }>;


export type CollectionCreate_BaseQuery = { __typename?: 'Query', me?: Maybe<{ __typename?: 'User', id: string, userName: string, displayName?: Maybe<string>, globalRoles?: Maybe<Array<Maybe<Role>>> }> };

export type GetCollectionQueryVariables = Exact<{
  collection_id: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  searchString?: Maybe<Scalars['String']>;
}>;


export type GetCollectionQuery = { __typename?: 'Query', getCollection?: Maybe<{ __typename?: 'Collection', id: string, name: string, myRoles: Array<Role>, posts?: Maybe<{ __typename?: 'PostPage', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<Maybe<{ __typename?: 'PostEdge', cursor: string, node: { __typename?: 'Post', id: string, title: string, primaryPoster?: Maybe<{ __typename?: 'ImageFile', findFormat: { __typename?: 'ImageFileFormat', sourceUrl: string } }>, primaryVideo?: Maybe<{ __typename?: 'VideoFile', key: string, defaultFormat: { __typename?: 'VideoFileFormat', key: string } }> } }>> }> }> };

export type GetCollectionHeaderQueryVariables = Exact<{
  collection_id: Scalars['String'];
}>;


export type GetCollectionHeaderQuery = { __typename?: 'Query', getCollection?: Maybe<{ __typename?: 'Collection', id: string, name: string, myRoles: Array<Role> }>, me?: Maybe<{ __typename?: 'User', id: string, userName: string, displayName?: Maybe<string>, globalRoles?: Maybe<Array<Maybe<Role>>> }> };

export type PostCard_PostFragment = { __typename?: 'Post', id: string, title: string, primaryPoster?: Maybe<{ __typename?: 'ImageFile', findFormat: { __typename?: 'ImageFileFormat', sourceUrl: string } }>, primaryVideo?: Maybe<{ __typename?: 'VideoFile', key: string, defaultFormat: { __typename?: 'VideoFileFormat', key: string } }> };

export type PostList_PostPageFragment = { __typename?: 'PostPage', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<Maybe<{ __typename?: 'PostEdge', cursor: string, node: { __typename?: 'Post', id: string, title: string, primaryPoster?: Maybe<{ __typename?: 'ImageFile', findFormat: { __typename?: 'ImageFileFormat', sourceUrl: string } }>, primaryVideo?: Maybe<{ __typename?: 'VideoFile', key: string, defaultFormat: { __typename?: 'VideoFileFormat', key: string } }> } }>> };

export type PostList_CollectionFragment = { __typename?: 'Collection', id: string };

export type GetPlaylistAuditRecordFragmentFragment = { __typename?: 'AuditRecord', date?: Maybe<any>, user?: Maybe<{ __typename?: 'User', id: string, givenName?: Maybe<string>, familyName?: Maybe<string>, userName: string }> };

export type GetPlaylistEditFragment = { __typename?: 'Playlist', id: string, title: string, myRoles: Array<Role>, created?: Maybe<{ __typename?: 'AuditRecord', date?: Maybe<any>, user?: Maybe<{ __typename?: 'User', id: string, givenName?: Maybe<string>, familyName?: Maybe<string>, userName: string }> }>, updated?: Maybe<{ __typename?: 'AuditRecord', date?: Maybe<any>, user?: Maybe<{ __typename?: 'User', id: string, givenName?: Maybe<string>, familyName?: Maybe<string>, userName: string }> }>, collection: { __typename?: 'Collection', id: string, name: string, myRoles: Array<Role>, groups?: Maybe<Array<Maybe<{ __typename: 'Group', id: string, name: string }>>> }, roleGrants?: Maybe<Array<Maybe<{ __typename?: 'UserRole', role: Role, principal: { __typename: 'User', id: string, userName: string, givenName?: Maybe<string>, familyName?: Maybe<string>, displayName?: Maybe<string> } | { __typename: 'Group', id: string, name: string } | { __typename: 'UserCategoryMember', userCategory: UserCategory } }>>> };

export type GetPlaylistEditQueryVariables = Exact<{
  collection_id: Scalars['String'];
  playlist_id: Scalars['String'];
}>;


export type GetPlaylistEditQuery = { __typename?: 'Query', getCollection?: Maybe<{ __typename?: 'Collection', getPlaylist?: Maybe<{ __typename?: 'Playlist', id: string, title: string, myRoles: Array<Role>, created?: Maybe<{ __typename?: 'AuditRecord', date?: Maybe<any>, user?: Maybe<{ __typename?: 'User', id: string, givenName?: Maybe<string>, familyName?: Maybe<string>, userName: string }> }>, updated?: Maybe<{ __typename?: 'AuditRecord', date?: Maybe<any>, user?: Maybe<{ __typename?: 'User', id: string, givenName?: Maybe<string>, familyName?: Maybe<string>, userName: string }> }>, collection: { __typename?: 'Collection', id: string, name: string, myRoles: Array<Role>, groups?: Maybe<Array<Maybe<{ __typename: 'Group', id: string, name: string }>>> }, roleGrants?: Maybe<Array<Maybe<{ __typename?: 'UserRole', role: Role, principal: { __typename: 'User', id: string, userName: string, givenName?: Maybe<string>, familyName?: Maybe<string>, displayName?: Maybe<string> } | { __typename: 'Group', id: string, name: string } | { __typename: 'UserCategoryMember', userCategory: UserCategory } }>>> }> }>, me?: Maybe<{ __typename?: 'User', id: string, userName: string, displayName?: Maybe<string>, globalRoles?: Maybe<Array<Maybe<Role>>> }> };

export type UpdatePlaylistMutationVariables = Exact<{
  playlist_id: Scalars['String'];
  input: PlaylistUpdateInput;
}>;


export type UpdatePlaylistMutation = { __typename?: 'Mutation', updatePlaylist?: Maybe<{ __typename?: 'Playlist', id: string, title: string, myRoles: Array<Role>, created?: Maybe<{ __typename?: 'AuditRecord', date?: Maybe<any>, user?: Maybe<{ __typename?: 'User', id: string, givenName?: Maybe<string>, familyName?: Maybe<string>, userName: string }> }>, updated?: Maybe<{ __typename?: 'AuditRecord', date?: Maybe<any>, user?: Maybe<{ __typename?: 'User', id: string, givenName?: Maybe<string>, familyName?: Maybe<string>, userName: string }> }>, collection: { __typename?: 'Collection', id: string, name: string, myRoles: Array<Role>, groups?: Maybe<Array<Maybe<{ __typename: 'Group', id: string, name: string }>>> }, roleGrants?: Maybe<Array<Maybe<{ __typename?: 'UserRole', role: Role, principal: { __typename: 'User', id: string, userName: string, givenName?: Maybe<string>, familyName?: Maybe<string>, displayName?: Maybe<string> } | { __typename: 'Group', id: string, name: string } | { __typename: 'UserCategoryMember', userCategory: UserCategory } }>>> }> };

export type PlaylistCard_PlaylistFragment = { __typename?: 'Playlist', id: string, title: string, numPosts?: Maybe<number>, isAvailable?: Maybe<boolean>, isAvailableMe?: Maybe<boolean>, availableStartDate?: Maybe<any>, availableEndDate?: Maybe<any> };

export type PlaylistTable_PlaylistFragment = { __typename?: 'Playlist', id: string, title: string, numPosts?: Maybe<number>, isAvailable?: Maybe<boolean>, isAvailableMe?: Maybe<boolean>, availableStartDate?: Maybe<any>, availableEndDate?: Maybe<any> };

export type PlaylistList_PlaylistFragment = { __typename?: 'Playlist', id: string, title: string, numPosts?: Maybe<number>, isAvailable?: Maybe<boolean>, isAvailableMe?: Maybe<boolean>, availableStartDate?: Maybe<any>, availableEndDate?: Maybe<any> };

export type PlaylistList_CollectionFragment = { __typename?: 'Collection', id: string, name: string, myRoles: Array<Role> };

export type PlaylistListPage_PlaylistPageFragment = { __typename?: 'PlaylistPage', edges: Array<Maybe<{ __typename?: 'PlaylistEdge', cursor: string, node: { __typename?: 'Playlist', id: string, title: string, numPosts?: Maybe<number>, isAvailable?: Maybe<boolean>, isAvailableMe?: Maybe<boolean>, availableStartDate?: Maybe<any>, availableEndDate?: Maybe<any> } }>>, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean } };

export type PlaylistList_BaseQueryVariables = Exact<{
  collection_id: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type PlaylistList_BaseQuery = { __typename?: 'Query', getCollection?: Maybe<{ __typename?: 'Collection', id: string, name: string, myRoles: Array<Role>, playlists?: Maybe<{ __typename?: 'PlaylistPage', edges: Array<Maybe<{ __typename?: 'PlaylistEdge', cursor: string, node: { __typename?: 'Playlist', id: string, title: string, numPosts?: Maybe<number>, isAvailable?: Maybe<boolean>, isAvailableMe?: Maybe<boolean>, availableStartDate?: Maybe<any>, availableEndDate?: Maybe<any> } }>>, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean } }> }>, me?: Maybe<{ __typename?: 'User', id: string, userName: string, displayName?: Maybe<string>, globalRoles?: Maybe<Array<Maybe<Role>>> }> };

export type PlaylistPostPage_BaseQueryVariables = Exact<{
  collection_id: Scalars['String'];
  playlist_id: Scalars['String'];
  post_index: Scalars['Int'];
}>;


export type PlaylistPostPage_BaseQuery = { __typename?: 'Query', getCollection?: Maybe<{ __typename?: 'Collection', name: string, id: string, myRoles: Array<Role>, getPlaylist?: Maybe<{ __typename?: 'Playlist', id: string, title: string, numPosts?: Maybe<number>, getPostByIndex?: Maybe<{ __typename?: 'PlaylistPostEntry', next_index?: Maybe<number>, prev_index?: Maybe<number>, index: number, post: { __typename?: 'Post', id: string, title: string, primaryVideo?: Maybe<{ __typename?: 'VideoFile', defaultFormat: { __typename?: 'VideoFileFormat', sourceUrl: string, contentType: string } }>, primaryPoster?: Maybe<{ __typename?: 'ImageFile', defaultFormat: { __typename?: 'ImageFileFormat', sourceUrl: string } }> } }> }> }>, me?: Maybe<{ __typename?: 'User', id: string, userName: string, displayName?: Maybe<string>, globalRoles?: Maybe<Array<Maybe<Role>>> }> };

export type PlaylistView_BaseQueryVariables = Exact<{
  collection_id: Scalars['String'];
  playlist_id: Scalars['String'];
}>;


export type PlaylistView_BaseQuery = { __typename?: 'Query', getCollection?: Maybe<{ __typename?: 'Collection', id: string, name: string, myRoles: Array<Role>, getPlaylist?: Maybe<{ __typename?: 'Playlist', id: string, title: string, myRoles: Array<Role>, posts?: Maybe<Array<{ __typename?: 'PlaylistPostEntry', index: number, post: { __typename?: 'Post', id: string, title: string, primaryPoster?: Maybe<{ __typename?: 'ImageFile', findFormat: { __typename?: 'ImageFileFormat', sourceUrl: string, width?: Maybe<number>, height?: Maybe<number> } }> } }>> }> }>, me?: Maybe<{ __typename?: 'User', id: string, userName: string, displayName?: Maybe<string>, globalRoles?: Maybe<Array<Maybe<Role>>> }> };

export type GetPostVideoFileFragmentFragment = { __typename?: 'VideoFile', key: string, formats: Array<{ __typename?: 'VideoFileFormat', contentType: string, key: string, width?: Maybe<number>, height?: Maybe<number>, frameRate?: Maybe<number>, default?: Maybe<boolean> }>, defaultFormat: { __typename?: 'VideoFileFormat', contentType: string, key: string, width?: Maybe<number>, height?: Maybe<number>, frameRate?: Maybe<number> }, created?: Maybe<{ __typename?: 'AuditRecord', date?: Maybe<any>, user?: Maybe<{ __typename?: 'User', id: string, givenName?: Maybe<string>, familyName?: Maybe<string>, userName: string }> }>, updated?: Maybe<{ __typename?: 'AuditRecord', date?: Maybe<any>, user?: Maybe<{ __typename?: 'User', id: string, givenName?: Maybe<string>, familyName?: Maybe<string>, userName: string }> }> };

export type GetPostAuditRecordFragmentFragment = { __typename?: 'AuditRecord', date?: Maybe<any>, user?: Maybe<{ __typename?: 'User', id: string, givenName?: Maybe<string>, familyName?: Maybe<string>, userName: string }> };

export type GetPostEditFragment = { __typename?: 'Post', id: string, title: string, myRoles: Array<Role>, created?: Maybe<{ __typename?: 'AuditRecord', date?: Maybe<any>, user?: Maybe<{ __typename?: 'User', id: string, givenName?: Maybe<string>, familyName?: Maybe<string>, userName: string }> }>, updated?: Maybe<{ __typename?: 'AuditRecord', date?: Maybe<any>, user?: Maybe<{ __typename?: 'User', id: string, givenName?: Maybe<string>, familyName?: Maybe<string>, userName: string }> }>, primaryVideo?: Maybe<{ __typename?: 'VideoFile', key: string, formats: Array<{ __typename?: 'VideoFileFormat', contentType: string, key: string, width?: Maybe<number>, height?: Maybe<number>, frameRate?: Maybe<number>, default?: Maybe<boolean> }>, defaultFormat: { __typename?: 'VideoFileFormat', contentType: string, key: string, width?: Maybe<number>, height?: Maybe<number>, frameRate?: Maybe<number> }, created?: Maybe<{ __typename?: 'AuditRecord', date?: Maybe<any>, user?: Maybe<{ __typename?: 'User', id: string, givenName?: Maybe<string>, familyName?: Maybe<string>, userName: string }> }>, updated?: Maybe<{ __typename?: 'AuditRecord', date?: Maybe<any>, user?: Maybe<{ __typename?: 'User', id: string, givenName?: Maybe<string>, familyName?: Maybe<string>, userName: string }> }> }>, primaryPoster?: Maybe<{ __typename?: 'ImageFile', findFormat: { __typename?: 'ImageFileFormat', sourceUrl: string }, defaultFormat: { __typename?: 'ImageFileFormat', sourceUrl: string, contentType: string } }>, collection: { __typename?: 'Collection', id: string, name: string, myRoles: Array<Role>, groups?: Maybe<Array<Maybe<{ __typename: 'Group', id: string, name: string }>>> }, roleGrants?: Maybe<Array<Maybe<{ __typename?: 'UserRole', role: Role, principal: { __typename: 'User', id: string, userName: string, givenName?: Maybe<string>, familyName?: Maybe<string>, displayName?: Maybe<string> } | { __typename: 'Group', id: string, name: string } | { __typename: 'UserCategoryMember', userCategory: UserCategory } }>>> };

export type GetPostEditQueryVariables = Exact<{
  collection_id: Scalars['String'];
  post_id: Scalars['String'];
}>;


export type GetPostEditQuery = { __typename?: 'Query', getCollection?: Maybe<{ __typename?: 'Collection', post?: Maybe<{ __typename?: 'Post', id: string, title: string, myRoles: Array<Role>, created?: Maybe<{ __typename?: 'AuditRecord', date?: Maybe<any>, user?: Maybe<{ __typename?: 'User', id: string, givenName?: Maybe<string>, familyName?: Maybe<string>, userName: string }> }>, updated?: Maybe<{ __typename?: 'AuditRecord', date?: Maybe<any>, user?: Maybe<{ __typename?: 'User', id: string, givenName?: Maybe<string>, familyName?: Maybe<string>, userName: string }> }>, primaryVideo?: Maybe<{ __typename?: 'VideoFile', key: string, formats: Array<{ __typename?: 'VideoFileFormat', contentType: string, key: string, width?: Maybe<number>, height?: Maybe<number>, frameRate?: Maybe<number>, default?: Maybe<boolean> }>, defaultFormat: { __typename?: 'VideoFileFormat', contentType: string, key: string, width?: Maybe<number>, height?: Maybe<number>, frameRate?: Maybe<number> }, created?: Maybe<{ __typename?: 'AuditRecord', date?: Maybe<any>, user?: Maybe<{ __typename?: 'User', id: string, givenName?: Maybe<string>, familyName?: Maybe<string>, userName: string }> }>, updated?: Maybe<{ __typename?: 'AuditRecord', date?: Maybe<any>, user?: Maybe<{ __typename?: 'User', id: string, givenName?: Maybe<string>, familyName?: Maybe<string>, userName: string }> }> }>, primaryPoster?: Maybe<{ __typename?: 'ImageFile', findFormat: { __typename?: 'ImageFileFormat', sourceUrl: string }, defaultFormat: { __typename?: 'ImageFileFormat', sourceUrl: string, contentType: string } }>, collection: { __typename?: 'Collection', id: string, name: string, myRoles: Array<Role>, groups?: Maybe<Array<Maybe<{ __typename: 'Group', id: string, name: string }>>> }, roleGrants?: Maybe<Array<Maybe<{ __typename?: 'UserRole', role: Role, principal: { __typename: 'User', id: string, userName: string, givenName?: Maybe<string>, familyName?: Maybe<string>, displayName?: Maybe<string> } | { __typename: 'Group', id: string, name: string } | { __typename: 'UserCategoryMember', userCategory: UserCategory } }>>> }> }>, me?: Maybe<{ __typename?: 'User', id: string, userName: string, displayName?: Maybe<string>, globalRoles?: Maybe<Array<Maybe<Role>>> }> };

export type UpdatePostMutationVariables = Exact<{
  id: Scalars['String'];
  input: PostInput;
}>;


export type UpdatePostMutation = { __typename?: 'Mutation', updatePost?: Maybe<{ __typename?: 'Post', id: string, title: string, myRoles: Array<Role>, created?: Maybe<{ __typename?: 'AuditRecord', date?: Maybe<any>, user?: Maybe<{ __typename?: 'User', id: string, givenName?: Maybe<string>, familyName?: Maybe<string>, userName: string }> }>, updated?: Maybe<{ __typename?: 'AuditRecord', date?: Maybe<any>, user?: Maybe<{ __typename?: 'User', id: string, givenName?: Maybe<string>, familyName?: Maybe<string>, userName: string }> }>, primaryVideo?: Maybe<{ __typename?: 'VideoFile', key: string, formats: Array<{ __typename?: 'VideoFileFormat', contentType: string, key: string, width?: Maybe<number>, height?: Maybe<number>, frameRate?: Maybe<number>, default?: Maybe<boolean> }>, defaultFormat: { __typename?: 'VideoFileFormat', contentType: string, key: string, width?: Maybe<number>, height?: Maybe<number>, frameRate?: Maybe<number> }, created?: Maybe<{ __typename?: 'AuditRecord', date?: Maybe<any>, user?: Maybe<{ __typename?: 'User', id: string, givenName?: Maybe<string>, familyName?: Maybe<string>, userName: string }> }>, updated?: Maybe<{ __typename?: 'AuditRecord', date?: Maybe<any>, user?: Maybe<{ __typename?: 'User', id: string, givenName?: Maybe<string>, familyName?: Maybe<string>, userName: string }> }> }>, primaryPoster?: Maybe<{ __typename?: 'ImageFile', findFormat: { __typename?: 'ImageFileFormat', sourceUrl: string }, defaultFormat: { __typename?: 'ImageFileFormat', sourceUrl: string, contentType: string } }>, collection: { __typename?: 'Collection', id: string, name: string, myRoles: Array<Role>, groups?: Maybe<Array<Maybe<{ __typename: 'Group', id: string, name: string }>>> }, roleGrants?: Maybe<Array<Maybe<{ __typename?: 'UserRole', role: Role, principal: { __typename: 'User', id: string, userName: string, givenName?: Maybe<string>, familyName?: Maybe<string>, displayName?: Maybe<string> } | { __typename: 'Group', id: string, name: string } | { __typename: 'UserCategoryMember', userCategory: UserCategory } }>>> }> };

export type DeleteMediaFileMutationVariables = Exact<{
  post_id: Scalars['String'];
  mediaFileKey: Scalars['String'];
}>;


export type DeleteMediaFileMutation = { __typename?: 'Mutation', deleteMediaFile?: Maybe<{ __typename?: 'Post', id: string, title: string, myRoles: Array<Role>, created?: Maybe<{ __typename?: 'AuditRecord', date?: Maybe<any>, user?: Maybe<{ __typename?: 'User', id: string, givenName?: Maybe<string>, familyName?: Maybe<string>, userName: string }> }>, updated?: Maybe<{ __typename?: 'AuditRecord', date?: Maybe<any>, user?: Maybe<{ __typename?: 'User', id: string, givenName?: Maybe<string>, familyName?: Maybe<string>, userName: string }> }>, primaryVideo?: Maybe<{ __typename?: 'VideoFile', key: string, formats: Array<{ __typename?: 'VideoFileFormat', contentType: string, key: string, width?: Maybe<number>, height?: Maybe<number>, frameRate?: Maybe<number>, default?: Maybe<boolean> }>, defaultFormat: { __typename?: 'VideoFileFormat', contentType: string, key: string, width?: Maybe<number>, height?: Maybe<number>, frameRate?: Maybe<number> }, created?: Maybe<{ __typename?: 'AuditRecord', date?: Maybe<any>, user?: Maybe<{ __typename?: 'User', id: string, givenName?: Maybe<string>, familyName?: Maybe<string>, userName: string }> }>, updated?: Maybe<{ __typename?: 'AuditRecord', date?: Maybe<any>, user?: Maybe<{ __typename?: 'User', id: string, givenName?: Maybe<string>, familyName?: Maybe<string>, userName: string }> }> }>, primaryPoster?: Maybe<{ __typename?: 'ImageFile', findFormat: { __typename?: 'ImageFileFormat', sourceUrl: string }, defaultFormat: { __typename?: 'ImageFileFormat', sourceUrl: string, contentType: string } }>, collection: { __typename?: 'Collection', id: string, name: string, myRoles: Array<Role>, groups?: Maybe<Array<Maybe<{ __typename: 'Group', id: string, name: string }>>> }, roleGrants?: Maybe<Array<Maybe<{ __typename?: 'UserRole', role: Role, principal: { __typename: 'User', id: string, userName: string, givenName?: Maybe<string>, familyName?: Maybe<string>, displayName?: Maybe<string> } | { __typename: 'Group', id: string, name: string } | { __typename: 'UserCategoryMember', userCategory: UserCategory } }>>> }> };

export type PostVideoBlock_PostFragment = { __typename?: 'Post', primaryVideo?: Maybe<{ __typename?: 'VideoFile', defaultFormat: { __typename?: 'VideoFileFormat', sourceUrl: string, contentType: string } }>, primaryPoster?: Maybe<{ __typename?: 'ImageFile', defaultFormat: { __typename?: 'ImageFileFormat', sourceUrl: string } }> };

export type PostTitleBlock_PostFragment = { __typename?: 'Post', id: string, title: string, collection: { __typename?: 'Collection', id: string, name: string } };

export type GetPostView_PostFragment = { __typename?: 'Post', id: string, title: string, myRoles: Array<Role>, primaryVideo?: Maybe<{ __typename?: 'VideoFile', defaultFormat: { __typename?: 'VideoFileFormat', sourceUrl: string, contentType: string } }>, primaryPoster?: Maybe<{ __typename?: 'ImageFile', defaultFormat: { __typename?: 'ImageFileFormat', sourceUrl: string } }>, collection: { __typename?: 'Collection', id: string, name: string } };

export type GetPostView_CollectionFragment = { __typename?: 'Collection', id: string, name: string, myRoles: Array<Role> };

export type GetPostViewQueryVariables = Exact<{
  collection_id: Scalars['String'];
  post_id: Scalars['String'];
}>;


export type GetPostViewQuery = { __typename?: 'Query', getCollection?: Maybe<{ __typename?: 'Collection', id: string, name: string, myRoles: Array<Role>, post?: Maybe<{ __typename?: 'Post', id: string, title: string, myRoles: Array<Role>, primaryVideo?: Maybe<{ __typename?: 'VideoFile', defaultFormat: { __typename?: 'VideoFileFormat', sourceUrl: string, contentType: string } }>, primaryPoster?: Maybe<{ __typename?: 'ImageFile', defaultFormat: { __typename?: 'ImageFileFormat', sourceUrl: string } }>, collection: { __typename?: 'Collection', id: string, name: string } }> }>, me?: Maybe<{ __typename?: 'User', id: string, userName: string, displayName?: Maybe<string>, globalRoles?: Maybe<Array<Maybe<Role>>> }> };

export type PostEdit_EvaluationsPanel_PostFragment = { __typename?: 'Post', evaluations: Array<Maybe<{ __typename?: 'Evaluation', id: string, status: EvaluationStatus, author?: Maybe<{ __typename?: 'User', id: string, userName: string, givenName?: Maybe<string>, familyName?: Maybe<string> }>, evaluationType: { __typename?: 'EvaluationType', key: string, name: string } }>> };

export type PostEdit_EvaluationsPanel_QueryFragment = { __typename?: 'Query', evaluationTypes: Array<Maybe<{ __typename?: 'EvaluationType', key: string, name: string }>> };

export type CollectionChrome_CollectionFragment = { __typename?: 'Collection', id: string, name: string, myRoles: Array<Role> };

export type CollectionChrome_UserFragment = { __typename?: 'User', id: string, userName: string, displayName?: Maybe<string>, globalRoles?: Maybe<Array<Maybe<Role>>> };

export type CollectionHeader_UserFragment = { __typename?: 'User', id: string, userName: string, displayName?: Maybe<string>, globalRoles?: Maybe<Array<Maybe<Role>>> };

export type CollectionHeader_CollectionFragment = { __typename?: 'Collection', myRoles: Array<Role> };

export type CollectionNav_CollectionFragment = { __typename?: 'Collection', id: string, name: string, myRoles: Array<Role> };

export type GroupEditUserFragment = { __typename?: 'User', id: string, userName: string, givenName?: Maybe<string>, familyName?: Maybe<string>, displayName?: Maybe<string> };

export type GroupEditorFragment = { __typename: 'Group', id: string, name: string, users: Array<Maybe<{ __typename?: 'User', id: string, userName: string, givenName?: Maybe<string>, familyName?: Maybe<string>, displayName?: Maybe<string> }>> };

export type RootChrome_UserFragment = { __typename?: 'User', id: string, userName: string, displayName?: Maybe<string>, globalRoles?: Maybe<Array<Maybe<Role>>> };

export type RootHeader_UserFragment = { __typename?: 'User', id: string, userName: string, displayName?: Maybe<string>, globalRoles?: Maybe<Array<Maybe<Role>>> };

export type UserRoleListFragment = { __typename?: 'UserRole', role: Role, principal: { __typename: 'User', id: string, userName: string, givenName?: Maybe<string>, familyName?: Maybe<string>, displayName?: Maybe<string> } | { __typename: 'Group', id: string, name: string } | { __typename: 'UserCategoryMember', userCategory: UserCategory } };

export type UserSearchBox_UserFragment = { __typename?: 'User', id: string, givenName?: Maybe<string>, familyName?: Maybe<string>, displayName?: Maybe<string>, userName: string };

export type UserSearchBox_FindUserQueryVariables = Exact<{
  collection_id: Scalars['String'];
  userName: Scalars['String'];
}>;


export type UserSearchBox_FindUserQuery = { __typename?: 'Query', getCollection?: Maybe<{ __typename?: 'Collection', findUser?: Maybe<{ __typename?: 'User', id: string, givenName?: Maybe<string>, familyName?: Maybe<string>, displayName?: Maybe<string>, userName: string }> }> };

export type UserSearchBox_CreatePlaceholderUserMutationVariables = Exact<{
  collection_id: Scalars['String'];
  userName: Scalars['String'];
}>;


export type UserSearchBox_CreatePlaceholderUserMutation = { __typename?: 'Mutation', createPlaceholderUser: { __typename?: 'User', id: string, givenName?: Maybe<string>, familyName?: Maybe<string>, displayName?: Maybe<string>, userName: string } };

export type ProfileMenu_UserFragment = { __typename?: 'User', id: string, userName: string, displayName?: Maybe<string>, globalRoles?: Maybe<Array<Maybe<Role>>> };

export type CreateCollectionMutationVariables = Exact<{
  input: CollectionInput;
}>;


export type CreateCollectionMutation = { __typename?: 'Mutation', createCollection?: Maybe<{ __typename?: 'Collection', id: string, name: string }> };

export type CreatePostMutationVariables = Exact<{
  collection_id: Scalars['String'];
}>;


export type CreatePostMutation = { __typename?: 'Mutation', createPost?: Maybe<{ __typename?: 'Post', id: string, title: string, myRoles: Array<Role>, primaryVideo?: Maybe<{ __typename?: 'VideoFile', defaultFormat: { __typename?: 'VideoFileFormat', sourceUrl: string, contentType: string } }>, primaryPoster?: Maybe<{ __typename?: 'ImageFile', defaultFormat: { __typename?: 'ImageFileFormat', sourceUrl: string } }>, collection: { __typename?: 'Collection', id: string, name: string } }> };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', me?: Maybe<{ __typename: 'User', id: string, userName: string }> };

export type StartPostMediaUploadMutationVariables = Exact<{
  post_id: Scalars['String'];
  contentType: Scalars['String'];
}>;


export type StartPostMediaUploadMutation = { __typename?: 'Mutation', startPostMediaUpload?: Maybe<{ __typename?: 'MediaUploadInfo', uploadUri: string, uploadKey: string }> };

export type CompletePostMediaUploadMutationVariables = Exact<{
  uploadKey?: Maybe<Scalars['String']>;
}>;


export type CompletePostMediaUploadMutation = { __typename?: 'Mutation', completePostMediaUpload?: Maybe<{ __typename?: 'PostMediaUploadResult', sourceUrl: string, contentType: string, post: { __typename?: 'Post', primaryVideo?: Maybe<{ __typename?: 'VideoFile', key: string }>, primaryPoster?: Maybe<{ __typename?: 'ImageFile', key: string }> } }> };

export type GetDownloadUrlQueryVariables = Exact<{
  collection_id: Scalars['String'];
  post_id: Scalars['String'];
  media_key: Scalars['String'];
  format_key: Scalars['String'];
}>;


export type GetDownloadUrlQuery = { __typename?: 'Query', getCollection?: Maybe<{ __typename?: 'Collection', post?: Maybe<{ __typename?: 'Post', mediaFile?: Maybe<{ __typename?: 'ImageFile', format?: Maybe<{ __typename?: 'ImageFileFormat', downloadUrl?: Maybe<string> }> } | { __typename?: 'VideoFile', format?: Maybe<{ __typename?: 'VideoFileFormat', downloadUrl?: Maybe<string> }> }> }> }> };

export const AssignmentCard_AssignmentFragmentDoc = gql`
    fragment AssignmentCard_Assignment on Assignment {
  id
  title
  status
  assignedToMe
  availableStartDate
  availableEndDate
  numRounds
}
    `;
export const AssignmentTable_AssignmentFragmentDoc = gql`
    fragment AssignmentTable_Assignment on Assignment {
  ...AssignmentCard_Assignment
}
    ${AssignmentCard_AssignmentFragmentDoc}`;
export const AssignmentList_AssignmentFragmentDoc = gql`
    fragment AssignmentList_Assignment on Assignment {
  ...AssignmentTable_Assignment
}
    ${AssignmentTable_AssignmentFragmentDoc}`;
export const CollectionNav_CollectionFragmentDoc = gql`
    fragment CollectionNav_Collection on Collection {
  id
  name
  myRoles
}
    `;
export const CollectionHeader_CollectionFragmentDoc = gql`
    fragment CollectionHeader_Collection on Collection {
  myRoles
}
    `;
export const CollectionChrome_CollectionFragmentDoc = gql`
    fragment CollectionChrome_Collection on Collection {
  ...CollectionNav_Collection
  ...CollectionHeader_Collection
}
    ${CollectionNav_CollectionFragmentDoc}
${CollectionHeader_CollectionFragmentDoc}`;
export const AssignmentList_CollectionFragmentDoc = gql`
    fragment AssignmentList_Collection on Collection {
  ...CollectionChrome_Collection
}
    ${CollectionChrome_CollectionFragmentDoc}`;
export const UserRoleListFragmentDoc = gql`
    fragment userRoleList on UserRole {
  principal {
    __typename
    ... on User {
      id
      userName
      givenName
      familyName
      displayName
    }
    ... on Group {
      id
      name
    }
    ... on UserCategoryMember {
      userCategory
    }
  }
  role
}
    `;
export const GroupEditUserFragmentDoc = gql`
    fragment GroupEditUser on User {
  id
  userName
  givenName
  familyName
  displayName
}
    `;
export const GroupEditorFragmentDoc = gql`
    fragment groupEditor on Group {
  __typename
  id
  name
  users {
    ...GroupEditUser
  }
}
    ${GroupEditUserFragmentDoc}`;
export const EditCollCollFragmentDoc = gql`
    fragment editCollColl on Collection {
  id
  name
  unlisted
  userRoles {
    ...userRoleList
  }
  groups {
    ...groupEditor
  }
  ...CollectionChrome_Collection
}
    ${UserRoleListFragmentDoc}
${GroupEditorFragmentDoc}
${CollectionChrome_CollectionFragmentDoc}`;
export const PostCard_PostFragmentDoc = gql`
    fragment PostCard_Post on Post {
  id
  title
  primaryPoster {
    findFormat(preferredHeight: 96) {
      sourceUrl
    }
  }
  primaryVideo {
    key
    defaultFormat {
      key
    }
  }
}
    `;
export const PostList_PostPageFragmentDoc = gql`
    fragment PostList_PostPage on PostPage {
  pageInfo {
    hasNextPage
    hasPreviousPage
  }
  edges {
    cursor
    node {
      id
      ...PostCard_Post
    }
  }
}
    ${PostCard_PostFragmentDoc}`;
export const PostList_CollectionFragmentDoc = gql`
    fragment PostList_Collection on Collection {
  id
}
    `;
export const GetPlaylistAuditRecordFragmentFragmentDoc = gql`
    fragment getPlaylistAuditRecordFragment on AuditRecord {
  user {
    id
    givenName
    familyName
    userName
  }
  date
}
    `;
export const GetPlaylistEditFragmentDoc = gql`
    fragment getPlaylistEdit on Playlist {
  id
  title
  myRoles
  created {
    ...getPlaylistAuditRecordFragment
  }
  updated {
    ...getPlaylistAuditRecordFragment
  }
  collection {
    id
    name
    myRoles
    groups {
      id
      name
      __typename
    }
  }
  roleGrants {
    ...userRoleList
  }
}
    ${GetPlaylistAuditRecordFragmentFragmentDoc}
${UserRoleListFragmentDoc}`;
export const PlaylistCard_PlaylistFragmentDoc = gql`
    fragment PlaylistCard_Playlist on Playlist {
  id
  title
  numPosts
  isAvailable
  isAvailableMe
  availableStartDate
  availableEndDate
}
    `;
export const PlaylistList_PlaylistFragmentDoc = gql`
    fragment PlaylistList_Playlist on Playlist {
  ...PlaylistCard_Playlist
}
    ${PlaylistCard_PlaylistFragmentDoc}`;
export const PlaylistList_CollectionFragmentDoc = gql`
    fragment PlaylistList_Collection on Collection {
  ...CollectionChrome_Collection
}
    ${CollectionChrome_CollectionFragmentDoc}`;
export const PlaylistTable_PlaylistFragmentDoc = gql`
    fragment PlaylistTable_Playlist on Playlist {
  ...PlaylistCard_Playlist
}
    ${PlaylistCard_PlaylistFragmentDoc}`;
export const PlaylistListPage_PlaylistPageFragmentDoc = gql`
    fragment PlaylistListPage_PlaylistPage on PlaylistPage {
  edges {
    node {
      ...PlaylistTable_Playlist
    }
    cursor
  }
  pageInfo {
    hasPreviousPage
    hasNextPage
  }
}
    ${PlaylistTable_PlaylistFragmentDoc}`;
export const GetPostAuditRecordFragmentFragmentDoc = gql`
    fragment getPostAuditRecordFragment on AuditRecord {
  user {
    id
    givenName
    familyName
    userName
  }
  date
}
    `;
export const GetPostVideoFileFragmentFragmentDoc = gql`
    fragment getPostVideoFileFragment on VideoFile {
  key
  formats {
    contentType
  }
  defaultFormat {
    contentType
    key
    width
    height
    frameRate
    contentType
  }
  formats {
    contentType
    key
    width
    height
    frameRate
    contentType
    default
  }
  created {
    ...getPostAuditRecordFragment
  }
  updated {
    ...getPostAuditRecordFragment
  }
}
    ${GetPostAuditRecordFragmentFragmentDoc}`;
export const GetPostEditFragmentDoc = gql`
    fragment getPostEdit on Post {
  id
  title
  myRoles
  created {
    ...getPostAuditRecordFragment
  }
  updated {
    ...getPostAuditRecordFragment
  }
  primaryVideo {
    ...getPostVideoFileFragment
  }
  primaryPoster {
    findFormat(preferredHeight: 96) {
      sourceUrl
    }
    defaultFormat {
      sourceUrl
      contentType
    }
  }
  collection {
    id
    name
    myRoles
    groups {
      id
      name
      __typename
    }
  }
  roleGrants {
    ...userRoleList
  }
}
    ${GetPostAuditRecordFragmentFragmentDoc}
${GetPostVideoFileFragmentFragmentDoc}
${UserRoleListFragmentDoc}`;
export const PostVideoBlock_PostFragmentDoc = gql`
    fragment PostVideoBlock_Post on Post {
  primaryVideo {
    defaultFormat {
      sourceUrl
      contentType
    }
  }
  primaryPoster {
    defaultFormat {
      sourceUrl
    }
  }
}
    `;
export const PostTitleBlock_PostFragmentDoc = gql`
    fragment PostTitleBlock_Post on Post {
  id
  title
  collection {
    id
    name
  }
}
    `;
export const GetPostView_PostFragmentDoc = gql`
    fragment GetPostView_Post on Post {
  id
  title
  myRoles
  ...PostVideoBlock_Post
  ...PostTitleBlock_Post
}
    ${PostVideoBlock_PostFragmentDoc}
${PostTitleBlock_PostFragmentDoc}`;
export const GetPostView_CollectionFragmentDoc = gql`
    fragment GetPostView_Collection on Collection {
  id
  name
  myRoles
}
    `;
export const PostEdit_EvaluationsPanel_PostFragmentDoc = gql`
    fragment postEdit_evaluationsPanel_post on Post {
  evaluations {
    id
    author {
      id
      userName
      givenName
      familyName
    }
    evaluationType {
      key
      name
    }
    status
  }
}
    `;
export const PostEdit_EvaluationsPanel_QueryFragmentDoc = gql`
    fragment postEdit_evaluationsPanel_query on Query {
  evaluationTypes {
    key
    name
  }
}
    `;
export const ProfileMenu_UserFragmentDoc = gql`
    fragment ProfileMenu_User on User {
  id
  userName
  displayName
  globalRoles
}
    `;
export const CollectionHeader_UserFragmentDoc = gql`
    fragment CollectionHeader_User on User {
  ...ProfileMenu_User
}
    ${ProfileMenu_UserFragmentDoc}`;
export const CollectionChrome_UserFragmentDoc = gql`
    fragment CollectionChrome_User on User {
  ...CollectionHeader_User
}
    ${CollectionHeader_UserFragmentDoc}`;
export const RootChrome_UserFragmentDoc = gql`
    fragment RootChrome_User on User {
  ...CollectionHeader_User
}
    ${CollectionHeader_UserFragmentDoc}`;
export const RootHeader_UserFragmentDoc = gql`
    fragment RootHeader_User on User {
  ...ProfileMenu_User
}
    ${ProfileMenu_UserFragmentDoc}`;
export const UserSearchBox_UserFragmentDoc = gql`
    fragment userSearchBox_user on User {
  id
  givenName
  familyName
  displayName
  userName
}
    `;
export const AssignmentList_BaseDocument = gql`
    query AssignmentList_Base($collection_id: String!) {
  getCollection(collection_id: $collection_id) {
    ...AssignmentList_Collection
    assignments {
      ...AssignmentList_Assignment
    }
  }
  me {
    ...CollectionChrome_User
  }
}
    ${AssignmentList_CollectionFragmentDoc}
${AssignmentList_AssignmentFragmentDoc}
${CollectionChrome_UserFragmentDoc}`;

/**
 * __useAssignmentList_BaseQuery__
 *
 * To run a query within a React component, call `useAssignmentList_BaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentList_BaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentList_BaseQuery({
 *   variables: {
 *      collection_id: // value for 'collection_id'
 *   },
 * });
 */
export function useAssignmentList_BaseQuery(baseOptions: Apollo.QueryHookOptions<AssignmentList_BaseQuery, AssignmentList_BaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssignmentList_BaseQuery, AssignmentList_BaseQueryVariables>(AssignmentList_BaseDocument, options);
      }
export function useAssignmentList_BaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssignmentList_BaseQuery, AssignmentList_BaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssignmentList_BaseQuery, AssignmentList_BaseQueryVariables>(AssignmentList_BaseDocument, options);
        }
export type AssignmentList_BaseQueryHookResult = ReturnType<typeof useAssignmentList_BaseQuery>;
export type AssignmentList_BaseLazyQueryHookResult = ReturnType<typeof useAssignmentList_BaseLazyQuery>;
export type AssignmentList_BaseQueryResult = Apollo.QueryResult<AssignmentList_BaseQuery, AssignmentList_BaseQueryVariables>;
export const EditCollgetCollDocument = gql`
    query editCollgetColl($collection_id: String!) {
  getCollection(collection_id: $collection_id) {
    ...editCollColl
  }
  me {
    ...CollectionChrome_User
  }
}
    ${EditCollCollFragmentDoc}
${CollectionChrome_UserFragmentDoc}`;

/**
 * __useEditCollgetCollQuery__
 *
 * To run a query within a React component, call `useEditCollgetCollQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditCollgetCollQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditCollgetCollQuery({
 *   variables: {
 *      collection_id: // value for 'collection_id'
 *   },
 * });
 */
export function useEditCollgetCollQuery(baseOptions: Apollo.QueryHookOptions<EditCollgetCollQuery, EditCollgetCollQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditCollgetCollQuery, EditCollgetCollQueryVariables>(EditCollgetCollDocument, options);
      }
export function useEditCollgetCollLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditCollgetCollQuery, EditCollgetCollQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditCollgetCollQuery, EditCollgetCollQueryVariables>(EditCollgetCollDocument, options);
        }
export type EditCollgetCollQueryHookResult = ReturnType<typeof useEditCollgetCollQuery>;
export type EditCollgetCollLazyQueryHookResult = ReturnType<typeof useEditCollgetCollLazyQuery>;
export type EditCollgetCollQueryResult = Apollo.QueryResult<EditCollgetCollQuery, EditCollgetCollQueryVariables>;
export const EditCollUpdateCollDocument = gql`
    mutation editCollUpdateColl($collection_id: String!, $inp: CollectionInput) {
  updateCollection(collection_id: $collection_id, input: $inp) {
    ...editCollColl
  }
}
    ${EditCollCollFragmentDoc}`;
export type EditCollUpdateCollMutationFn = Apollo.MutationFunction<EditCollUpdateCollMutation, EditCollUpdateCollMutationVariables>;

/**
 * __useEditCollUpdateCollMutation__
 *
 * To run a mutation, you first call `useEditCollUpdateCollMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCollUpdateCollMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCollUpdateCollMutation, { data, loading, error }] = useEditCollUpdateCollMutation({
 *   variables: {
 *      collection_id: // value for 'collection_id'
 *      inp: // value for 'inp'
 *   },
 * });
 */
export function useEditCollUpdateCollMutation(baseOptions?: Apollo.MutationHookOptions<EditCollUpdateCollMutation, EditCollUpdateCollMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCollUpdateCollMutation, EditCollUpdateCollMutationVariables>(EditCollUpdateCollDocument, options);
      }
export type EditCollUpdateCollMutationHookResult = ReturnType<typeof useEditCollUpdateCollMutation>;
export type EditCollUpdateCollMutationResult = Apollo.MutationResult<EditCollUpdateCollMutation>;
export type EditCollUpdateCollMutationOptions = Apollo.BaseMutationOptions<EditCollUpdateCollMutation, EditCollUpdateCollMutationVariables>;
export const GetCollectionsListDocument = gql`
    query getCollectionsList {
  getCollections {
    id
    name
    myRoles
  }
  myRoles
  me {
    ...CollectionChrome_User
  }
}
    ${CollectionChrome_UserFragmentDoc}`;

/**
 * __useGetCollectionsListQuery__
 *
 * To run a query within a React component, call `useGetCollectionsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCollectionsListQuery(baseOptions?: Apollo.QueryHookOptions<GetCollectionsListQuery, GetCollectionsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionsListQuery, GetCollectionsListQueryVariables>(GetCollectionsListDocument, options);
      }
export function useGetCollectionsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionsListQuery, GetCollectionsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionsListQuery, GetCollectionsListQueryVariables>(GetCollectionsListDocument, options);
        }
export type GetCollectionsListQueryHookResult = ReturnType<typeof useGetCollectionsListQuery>;
export type GetCollectionsListLazyQueryHookResult = ReturnType<typeof useGetCollectionsListLazyQuery>;
export type GetCollectionsListQueryResult = Apollo.QueryResult<GetCollectionsListQuery, GetCollectionsListQueryVariables>;
export const CollectionCreate_BaseDocument = gql`
    query CollectionCreate_base {
  me {
    ...RootChrome_User
  }
}
    ${RootChrome_UserFragmentDoc}`;

/**
 * __useCollectionCreate_BaseQuery__
 *
 * To run a query within a React component, call `useCollectionCreate_BaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionCreate_BaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionCreate_BaseQuery({
 *   variables: {
 *   },
 * });
 */
export function useCollectionCreate_BaseQuery(baseOptions?: Apollo.QueryHookOptions<CollectionCreate_BaseQuery, CollectionCreate_BaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CollectionCreate_BaseQuery, CollectionCreate_BaseQueryVariables>(CollectionCreate_BaseDocument, options);
      }
export function useCollectionCreate_BaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CollectionCreate_BaseQuery, CollectionCreate_BaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CollectionCreate_BaseQuery, CollectionCreate_BaseQueryVariables>(CollectionCreate_BaseDocument, options);
        }
export type CollectionCreate_BaseQueryHookResult = ReturnType<typeof useCollectionCreate_BaseQuery>;
export type CollectionCreate_BaseLazyQueryHookResult = ReturnType<typeof useCollectionCreate_BaseLazyQuery>;
export type CollectionCreate_BaseQueryResult = Apollo.QueryResult<CollectionCreate_BaseQuery, CollectionCreate_BaseQueryVariables>;
export const GetCollectionDocument = gql`
    query getCollection($collection_id: String!, $limit: Int, $after: String, $before: String, $searchString: String) {
  getCollection(collection_id: $collection_id) {
    id
    name
    myRoles
    ...PostList_Collection
    posts(
      limit: $limit
      after: $after
      before: $before
      searchString: $searchString
    ) {
      ...PostList_PostPage
    }
  }
}
    ${PostList_CollectionFragmentDoc}
${PostList_PostPageFragmentDoc}`;

/**
 * __useGetCollectionQuery__
 *
 * To run a query within a React component, call `useGetCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionQuery({
 *   variables: {
 *      collection_id: // value for 'collection_id'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      searchString: // value for 'searchString'
 *   },
 * });
 */
export function useGetCollectionQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionQuery, GetCollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionQuery, GetCollectionQueryVariables>(GetCollectionDocument, options);
      }
export function useGetCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionQuery, GetCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionQuery, GetCollectionQueryVariables>(GetCollectionDocument, options);
        }
export type GetCollectionQueryHookResult = ReturnType<typeof useGetCollectionQuery>;
export type GetCollectionLazyQueryHookResult = ReturnType<typeof useGetCollectionLazyQuery>;
export type GetCollectionQueryResult = Apollo.QueryResult<GetCollectionQuery, GetCollectionQueryVariables>;
export const GetCollectionHeaderDocument = gql`
    query getCollectionHeader($collection_id: String!) {
  getCollection(collection_id: $collection_id) {
    id
    name
    myRoles
  }
  me {
    ...CollectionChrome_User
  }
}
    ${CollectionChrome_UserFragmentDoc}`;

/**
 * __useGetCollectionHeaderQuery__
 *
 * To run a query within a React component, call `useGetCollectionHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionHeaderQuery({
 *   variables: {
 *      collection_id: // value for 'collection_id'
 *   },
 * });
 */
export function useGetCollectionHeaderQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionHeaderQuery, GetCollectionHeaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionHeaderQuery, GetCollectionHeaderQueryVariables>(GetCollectionHeaderDocument, options);
      }
export function useGetCollectionHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionHeaderQuery, GetCollectionHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionHeaderQuery, GetCollectionHeaderQueryVariables>(GetCollectionHeaderDocument, options);
        }
export type GetCollectionHeaderQueryHookResult = ReturnType<typeof useGetCollectionHeaderQuery>;
export type GetCollectionHeaderLazyQueryHookResult = ReturnType<typeof useGetCollectionHeaderLazyQuery>;
export type GetCollectionHeaderQueryResult = Apollo.QueryResult<GetCollectionHeaderQuery, GetCollectionHeaderQueryVariables>;
export const GetPlaylistEditDocument = gql`
    query getPlaylistEdit($collection_id: String!, $playlist_id: String!) {
  getCollection(collection_id: $collection_id) {
    getPlaylist(playlist_id: $playlist_id) {
      ...getPlaylistEdit
    }
  }
  me {
    ...CollectionChrome_User
  }
}
    ${GetPlaylistEditFragmentDoc}
${CollectionChrome_UserFragmentDoc}`;

/**
 * __useGetPlaylistEditQuery__
 *
 * To run a query within a React component, call `useGetPlaylistEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaylistEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaylistEditQuery({
 *   variables: {
 *      collection_id: // value for 'collection_id'
 *      playlist_id: // value for 'playlist_id'
 *   },
 * });
 */
export function useGetPlaylistEditQuery(baseOptions: Apollo.QueryHookOptions<GetPlaylistEditQuery, GetPlaylistEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlaylistEditQuery, GetPlaylistEditQueryVariables>(GetPlaylistEditDocument, options);
      }
export function useGetPlaylistEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlaylistEditQuery, GetPlaylistEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlaylistEditQuery, GetPlaylistEditQueryVariables>(GetPlaylistEditDocument, options);
        }
export type GetPlaylistEditQueryHookResult = ReturnType<typeof useGetPlaylistEditQuery>;
export type GetPlaylistEditLazyQueryHookResult = ReturnType<typeof useGetPlaylistEditLazyQuery>;
export type GetPlaylistEditQueryResult = Apollo.QueryResult<GetPlaylistEditQuery, GetPlaylistEditQueryVariables>;
export const UpdatePlaylistDocument = gql`
    mutation updatePlaylist($playlist_id: String!, $input: PlaylistUpdateInput!) {
  updatePlaylist(playlist_id: $playlist_id, input: $input) {
    ...getPlaylistEdit
  }
}
    ${GetPlaylistEditFragmentDoc}`;
export type UpdatePlaylistMutationFn = Apollo.MutationFunction<UpdatePlaylistMutation, UpdatePlaylistMutationVariables>;

/**
 * __useUpdatePlaylistMutation__
 *
 * To run a mutation, you first call `useUpdatePlaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlaylistMutation, { data, loading, error }] = useUpdatePlaylistMutation({
 *   variables: {
 *      playlist_id: // value for 'playlist_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlaylistMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlaylistMutation, UpdatePlaylistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlaylistMutation, UpdatePlaylistMutationVariables>(UpdatePlaylistDocument, options);
      }
export type UpdatePlaylistMutationHookResult = ReturnType<typeof useUpdatePlaylistMutation>;
export type UpdatePlaylistMutationResult = Apollo.MutationResult<UpdatePlaylistMutation>;
export type UpdatePlaylistMutationOptions = Apollo.BaseMutationOptions<UpdatePlaylistMutation, UpdatePlaylistMutationVariables>;
export const PlaylistList_BaseDocument = gql`
    query PlaylistList_Base($collection_id: String!, $limit: Int, $after: String, $before: String) {
  getCollection(collection_id: $collection_id) {
    ...PlaylistList_Collection
    playlists(limit: $limit, after: $after, before: $before) {
      ...PlaylistListPage_PlaylistPage
    }
  }
  me {
    ...CollectionChrome_User
  }
}
    ${PlaylistList_CollectionFragmentDoc}
${PlaylistListPage_PlaylistPageFragmentDoc}
${CollectionChrome_UserFragmentDoc}`;

/**
 * __usePlaylistList_BaseQuery__
 *
 * To run a query within a React component, call `usePlaylistList_BaseQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaylistList_BaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaylistList_BaseQuery({
 *   variables: {
 *      collection_id: // value for 'collection_id'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function usePlaylistList_BaseQuery(baseOptions: Apollo.QueryHookOptions<PlaylistList_BaseQuery, PlaylistList_BaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaylistList_BaseQuery, PlaylistList_BaseQueryVariables>(PlaylistList_BaseDocument, options);
      }
export function usePlaylistList_BaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaylistList_BaseQuery, PlaylistList_BaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaylistList_BaseQuery, PlaylistList_BaseQueryVariables>(PlaylistList_BaseDocument, options);
        }
export type PlaylistList_BaseQueryHookResult = ReturnType<typeof usePlaylistList_BaseQuery>;
export type PlaylistList_BaseLazyQueryHookResult = ReturnType<typeof usePlaylistList_BaseLazyQuery>;
export type PlaylistList_BaseQueryResult = Apollo.QueryResult<PlaylistList_BaseQuery, PlaylistList_BaseQueryVariables>;
export const PlaylistPostPage_BaseDocument = gql`
    query PlaylistPostPage_Base($collection_id: String!, $playlist_id: String!, $post_index: Int!) {
  getCollection(collection_id: $collection_id) {
    ...CollectionChrome_Collection
    name
    getPlaylist(playlist_id: $playlist_id) {
      id
      title
      numPosts
      getPostByIndex(post_index: $post_index) {
        post {
          id
          title
          ...PostVideoBlock_Post
        }
        next_index
        prev_index
        index
      }
    }
  }
  me {
    ...CollectionChrome_User
  }
}
    ${CollectionChrome_CollectionFragmentDoc}
${PostVideoBlock_PostFragmentDoc}
${CollectionChrome_UserFragmentDoc}`;

/**
 * __usePlaylistPostPage_BaseQuery__
 *
 * To run a query within a React component, call `usePlaylistPostPage_BaseQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaylistPostPage_BaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaylistPostPage_BaseQuery({
 *   variables: {
 *      collection_id: // value for 'collection_id'
 *      playlist_id: // value for 'playlist_id'
 *      post_index: // value for 'post_index'
 *   },
 * });
 */
export function usePlaylistPostPage_BaseQuery(baseOptions: Apollo.QueryHookOptions<PlaylistPostPage_BaseQuery, PlaylistPostPage_BaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaylistPostPage_BaseQuery, PlaylistPostPage_BaseQueryVariables>(PlaylistPostPage_BaseDocument, options);
      }
export function usePlaylistPostPage_BaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaylistPostPage_BaseQuery, PlaylistPostPage_BaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaylistPostPage_BaseQuery, PlaylistPostPage_BaseQueryVariables>(PlaylistPostPage_BaseDocument, options);
        }
export type PlaylistPostPage_BaseQueryHookResult = ReturnType<typeof usePlaylistPostPage_BaseQuery>;
export type PlaylistPostPage_BaseLazyQueryHookResult = ReturnType<typeof usePlaylistPostPage_BaseLazyQuery>;
export type PlaylistPostPage_BaseQueryResult = Apollo.QueryResult<PlaylistPostPage_BaseQuery, PlaylistPostPage_BaseQueryVariables>;
export const PlaylistView_BaseDocument = gql`
    query PlaylistView_Base($collection_id: String!, $playlist_id: String!) {
  getCollection(collection_id: $collection_id) {
    ...CollectionChrome_Collection
    getPlaylist(playlist_id: $playlist_id) {
      id
      title
      myRoles
      posts {
        index
        post {
          id
          title
          primaryPoster {
            findFormat(preferredHeight: 40) {
              sourceUrl
              width
              height
            }
          }
        }
      }
    }
  }
  me {
    ...CollectionChrome_User
  }
}
    ${CollectionChrome_CollectionFragmentDoc}
${CollectionChrome_UserFragmentDoc}`;

/**
 * __usePlaylistView_BaseQuery__
 *
 * To run a query within a React component, call `usePlaylistView_BaseQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaylistView_BaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaylistView_BaseQuery({
 *   variables: {
 *      collection_id: // value for 'collection_id'
 *      playlist_id: // value for 'playlist_id'
 *   },
 * });
 */
export function usePlaylistView_BaseQuery(baseOptions: Apollo.QueryHookOptions<PlaylistView_BaseQuery, PlaylistView_BaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaylistView_BaseQuery, PlaylistView_BaseQueryVariables>(PlaylistView_BaseDocument, options);
      }
export function usePlaylistView_BaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaylistView_BaseQuery, PlaylistView_BaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaylistView_BaseQuery, PlaylistView_BaseQueryVariables>(PlaylistView_BaseDocument, options);
        }
export type PlaylistView_BaseQueryHookResult = ReturnType<typeof usePlaylistView_BaseQuery>;
export type PlaylistView_BaseLazyQueryHookResult = ReturnType<typeof usePlaylistView_BaseLazyQuery>;
export type PlaylistView_BaseQueryResult = Apollo.QueryResult<PlaylistView_BaseQuery, PlaylistView_BaseQueryVariables>;
export const GetPostEditDocument = gql`
    query getPostEdit($collection_id: String!, $post_id: String!) {
  getCollection(collection_id: $collection_id) {
    post(post_id: $post_id) {
      ...getPostEdit
    }
  }
  me {
    ...CollectionChrome_User
  }
}
    ${GetPostEditFragmentDoc}
${CollectionChrome_UserFragmentDoc}`;

/**
 * __useGetPostEditQuery__
 *
 * To run a query within a React component, call `useGetPostEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostEditQuery({
 *   variables: {
 *      collection_id: // value for 'collection_id'
 *      post_id: // value for 'post_id'
 *   },
 * });
 */
export function useGetPostEditQuery(baseOptions: Apollo.QueryHookOptions<GetPostEditQuery, GetPostEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostEditQuery, GetPostEditQueryVariables>(GetPostEditDocument, options);
      }
export function useGetPostEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostEditQuery, GetPostEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostEditQuery, GetPostEditQueryVariables>(GetPostEditDocument, options);
        }
export type GetPostEditQueryHookResult = ReturnType<typeof useGetPostEditQuery>;
export type GetPostEditLazyQueryHookResult = ReturnType<typeof useGetPostEditLazyQuery>;
export type GetPostEditQueryResult = Apollo.QueryResult<GetPostEditQuery, GetPostEditQueryVariables>;
export const UpdatePostDocument = gql`
    mutation updatePost($id: String!, $input: PostInput!) {
  updatePost(id: $id, input: $input) {
    ...getPostEdit
  }
}
    ${GetPostEditFragmentDoc}`;
export type UpdatePostMutationFn = Apollo.MutationFunction<UpdatePostMutation, UpdatePostMutationVariables>;

/**
 * __useUpdatePostMutation__
 *
 * To run a mutation, you first call `useUpdatePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePostMutation, { data, loading, error }] = useUpdatePostMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePostMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePostMutation, UpdatePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePostMutation, UpdatePostMutationVariables>(UpdatePostDocument, options);
      }
export type UpdatePostMutationHookResult = ReturnType<typeof useUpdatePostMutation>;
export type UpdatePostMutationResult = Apollo.MutationResult<UpdatePostMutation>;
export type UpdatePostMutationOptions = Apollo.BaseMutationOptions<UpdatePostMutation, UpdatePostMutationVariables>;
export const DeleteMediaFileDocument = gql`
    mutation deleteMediaFile($post_id: String!, $mediaFileKey: String!) {
  deleteMediaFile(post_id: $post_id, mediaFileKey: $mediaFileKey) {
    ...getPostEdit
  }
}
    ${GetPostEditFragmentDoc}`;
export type DeleteMediaFileMutationFn = Apollo.MutationFunction<DeleteMediaFileMutation, DeleteMediaFileMutationVariables>;

/**
 * __useDeleteMediaFileMutation__
 *
 * To run a mutation, you first call `useDeleteMediaFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMediaFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMediaFileMutation, { data, loading, error }] = useDeleteMediaFileMutation({
 *   variables: {
 *      post_id: // value for 'post_id'
 *      mediaFileKey: // value for 'mediaFileKey'
 *   },
 * });
 */
export function useDeleteMediaFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMediaFileMutation, DeleteMediaFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMediaFileMutation, DeleteMediaFileMutationVariables>(DeleteMediaFileDocument, options);
      }
export type DeleteMediaFileMutationHookResult = ReturnType<typeof useDeleteMediaFileMutation>;
export type DeleteMediaFileMutationResult = Apollo.MutationResult<DeleteMediaFileMutation>;
export type DeleteMediaFileMutationOptions = Apollo.BaseMutationOptions<DeleteMediaFileMutation, DeleteMediaFileMutationVariables>;
export const GetPostViewDocument = gql`
    query getPostView($collection_id: String!, $post_id: String!) {
  getCollection(collection_id: $collection_id) {
    ...GetPostView_Collection
    post(post_id: $post_id) {
      ...GetPostView_Post
    }
  }
  me {
    ...CollectionChrome_User
  }
}
    ${GetPostView_CollectionFragmentDoc}
${GetPostView_PostFragmentDoc}
${CollectionChrome_UserFragmentDoc}`;

/**
 * __useGetPostViewQuery__
 *
 * To run a query within a React component, call `useGetPostViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostViewQuery({
 *   variables: {
 *      collection_id: // value for 'collection_id'
 *      post_id: // value for 'post_id'
 *   },
 * });
 */
export function useGetPostViewQuery(baseOptions: Apollo.QueryHookOptions<GetPostViewQuery, GetPostViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostViewQuery, GetPostViewQueryVariables>(GetPostViewDocument, options);
      }
export function useGetPostViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostViewQuery, GetPostViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostViewQuery, GetPostViewQueryVariables>(GetPostViewDocument, options);
        }
export type GetPostViewQueryHookResult = ReturnType<typeof useGetPostViewQuery>;
export type GetPostViewLazyQueryHookResult = ReturnType<typeof useGetPostViewLazyQuery>;
export type GetPostViewQueryResult = Apollo.QueryResult<GetPostViewQuery, GetPostViewQueryVariables>;
export const UserSearchBox_FindUserDocument = gql`
    query userSearchBox_findUser($collection_id: String!, $userName: String!) {
  getCollection(collection_id: $collection_id) {
    findUser(userName: $userName) {
      ...userSearchBox_user
    }
  }
}
    ${UserSearchBox_UserFragmentDoc}`;

/**
 * __useUserSearchBox_FindUserQuery__
 *
 * To run a query within a React component, call `useUserSearchBox_FindUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSearchBox_FindUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSearchBox_FindUserQuery({
 *   variables: {
 *      collection_id: // value for 'collection_id'
 *      userName: // value for 'userName'
 *   },
 * });
 */
export function useUserSearchBox_FindUserQuery(baseOptions: Apollo.QueryHookOptions<UserSearchBox_FindUserQuery, UserSearchBox_FindUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSearchBox_FindUserQuery, UserSearchBox_FindUserQueryVariables>(UserSearchBox_FindUserDocument, options);
      }
export function useUserSearchBox_FindUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSearchBox_FindUserQuery, UserSearchBox_FindUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSearchBox_FindUserQuery, UserSearchBox_FindUserQueryVariables>(UserSearchBox_FindUserDocument, options);
        }
export type UserSearchBox_FindUserQueryHookResult = ReturnType<typeof useUserSearchBox_FindUserQuery>;
export type UserSearchBox_FindUserLazyQueryHookResult = ReturnType<typeof useUserSearchBox_FindUserLazyQuery>;
export type UserSearchBox_FindUserQueryResult = Apollo.QueryResult<UserSearchBox_FindUserQuery, UserSearchBox_FindUserQueryVariables>;
export const UserSearchBox_CreatePlaceholderUserDocument = gql`
    mutation userSearchBox_createPlaceholderUser($collection_id: String!, $userName: String!) {
  createPlaceholderUser(collection_id: $collection_id, userName: $userName) {
    ...userSearchBox_user
  }
}
    ${UserSearchBox_UserFragmentDoc}`;
export type UserSearchBox_CreatePlaceholderUserMutationFn = Apollo.MutationFunction<UserSearchBox_CreatePlaceholderUserMutation, UserSearchBox_CreatePlaceholderUserMutationVariables>;

/**
 * __useUserSearchBox_CreatePlaceholderUserMutation__
 *
 * To run a mutation, you first call `useUserSearchBox_CreatePlaceholderUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserSearchBox_CreatePlaceholderUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userSearchBoxCreatePlaceholderUserMutation, { data, loading, error }] = useUserSearchBox_CreatePlaceholderUserMutation({
 *   variables: {
 *      collection_id: // value for 'collection_id'
 *      userName: // value for 'userName'
 *   },
 * });
 */
export function useUserSearchBox_CreatePlaceholderUserMutation(baseOptions?: Apollo.MutationHookOptions<UserSearchBox_CreatePlaceholderUserMutation, UserSearchBox_CreatePlaceholderUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserSearchBox_CreatePlaceholderUserMutation, UserSearchBox_CreatePlaceholderUserMutationVariables>(UserSearchBox_CreatePlaceholderUserDocument, options);
      }
export type UserSearchBox_CreatePlaceholderUserMutationHookResult = ReturnType<typeof useUserSearchBox_CreatePlaceholderUserMutation>;
export type UserSearchBox_CreatePlaceholderUserMutationResult = Apollo.MutationResult<UserSearchBox_CreatePlaceholderUserMutation>;
export type UserSearchBox_CreatePlaceholderUserMutationOptions = Apollo.BaseMutationOptions<UserSearchBox_CreatePlaceholderUserMutation, UserSearchBox_CreatePlaceholderUserMutationVariables>;
export const CreateCollectionDocument = gql`
    mutation createCollection($input: CollectionInput!) {
  createCollection(input: $input) {
    id
    name
  }
}
    `;
export type CreateCollectionMutationFn = Apollo.MutationFunction<CreateCollectionMutation, CreateCollectionMutationVariables>;

/**
 * __useCreateCollectionMutation__
 *
 * To run a mutation, you first call `useCreateCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCollectionMutation, { data, loading, error }] = useCreateCollectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCollectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateCollectionMutation, CreateCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCollectionMutation, CreateCollectionMutationVariables>(CreateCollectionDocument, options);
      }
export type CreateCollectionMutationHookResult = ReturnType<typeof useCreateCollectionMutation>;
export type CreateCollectionMutationResult = Apollo.MutationResult<CreateCollectionMutation>;
export type CreateCollectionMutationOptions = Apollo.BaseMutationOptions<CreateCollectionMutation, CreateCollectionMutationVariables>;
export const CreatePostDocument = gql`
    mutation createPost($collection_id: String!) {
  createPost(collection_id: $collection_id) {
    ...GetPostView_Post
  }
}
    ${GetPostView_PostFragmentDoc}`;
export type CreatePostMutationFn = Apollo.MutationFunction<CreatePostMutation, CreatePostMutationVariables>;

/**
 * __useCreatePostMutation__
 *
 * To run a mutation, you first call `useCreatePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostMutation, { data, loading, error }] = useCreatePostMutation({
 *   variables: {
 *      collection_id: // value for 'collection_id'
 *   },
 * });
 */
export function useCreatePostMutation(baseOptions?: Apollo.MutationHookOptions<CreatePostMutation, CreatePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePostMutation, CreatePostMutationVariables>(CreatePostDocument, options);
      }
export type CreatePostMutationHookResult = ReturnType<typeof useCreatePostMutation>;
export type CreatePostMutationResult = Apollo.MutationResult<CreatePostMutation>;
export type CreatePostMutationOptions = Apollo.BaseMutationOptions<CreatePostMutation, CreatePostMutationVariables>;
export const GetMeDocument = gql`
    query getMe {
  me {
    __typename
    id
    userName
  }
}
    `;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: Apollo.QueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
      }
export function useGetMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeQueryResult = Apollo.QueryResult<GetMeQuery, GetMeQueryVariables>;
export const StartPostMediaUploadDocument = gql`
    mutation startPostMediaUpload($post_id: String!, $contentType: String!) {
  startPostMediaUpload(post_id: $post_id, contentType: $contentType) {
    uploadUri
    uploadKey
  }
}
    `;
export type StartPostMediaUploadMutationFn = Apollo.MutationFunction<StartPostMediaUploadMutation, StartPostMediaUploadMutationVariables>;

/**
 * __useStartPostMediaUploadMutation__
 *
 * To run a mutation, you first call `useStartPostMediaUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartPostMediaUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startPostMediaUploadMutation, { data, loading, error }] = useStartPostMediaUploadMutation({
 *   variables: {
 *      post_id: // value for 'post_id'
 *      contentType: // value for 'contentType'
 *   },
 * });
 */
export function useStartPostMediaUploadMutation(baseOptions?: Apollo.MutationHookOptions<StartPostMediaUploadMutation, StartPostMediaUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartPostMediaUploadMutation, StartPostMediaUploadMutationVariables>(StartPostMediaUploadDocument, options);
      }
export type StartPostMediaUploadMutationHookResult = ReturnType<typeof useStartPostMediaUploadMutation>;
export type StartPostMediaUploadMutationResult = Apollo.MutationResult<StartPostMediaUploadMutation>;
export type StartPostMediaUploadMutationOptions = Apollo.BaseMutationOptions<StartPostMediaUploadMutation, StartPostMediaUploadMutationVariables>;
export const CompletePostMediaUploadDocument = gql`
    mutation completePostMediaUpload($uploadKey: String) {
  completePostMediaUpload(uploadKey: $uploadKey) {
    post {
      primaryVideo {
        key
      }
      primaryPoster {
        key
      }
    }
    sourceUrl
    contentType
  }
}
    `;
export type CompletePostMediaUploadMutationFn = Apollo.MutationFunction<CompletePostMediaUploadMutation, CompletePostMediaUploadMutationVariables>;

/**
 * __useCompletePostMediaUploadMutation__
 *
 * To run a mutation, you first call `useCompletePostMediaUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompletePostMediaUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completePostMediaUploadMutation, { data, loading, error }] = useCompletePostMediaUploadMutation({
 *   variables: {
 *      uploadKey: // value for 'uploadKey'
 *   },
 * });
 */
export function useCompletePostMediaUploadMutation(baseOptions?: Apollo.MutationHookOptions<CompletePostMediaUploadMutation, CompletePostMediaUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompletePostMediaUploadMutation, CompletePostMediaUploadMutationVariables>(CompletePostMediaUploadDocument, options);
      }
export type CompletePostMediaUploadMutationHookResult = ReturnType<typeof useCompletePostMediaUploadMutation>;
export type CompletePostMediaUploadMutationResult = Apollo.MutationResult<CompletePostMediaUploadMutation>;
export type CompletePostMediaUploadMutationOptions = Apollo.BaseMutationOptions<CompletePostMediaUploadMutation, CompletePostMediaUploadMutationVariables>;
export const GetDownloadUrlDocument = gql`
    query getDownloadUrl($collection_id: String!, $post_id: String!, $media_key: String!, $format_key: String!) {
  getCollection(collection_id: $collection_id) {
    post(post_id: $post_id) {
      mediaFile(mediafile_key: $media_key) {
        format(format_key: $format_key) {
          downloadUrl
        }
      }
    }
  }
}
    `;

/**
 * __useGetDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDownloadUrlQuery({
 *   variables: {
 *      collection_id: // value for 'collection_id'
 *      post_id: // value for 'post_id'
 *      media_key: // value for 'media_key'
 *      format_key: // value for 'format_key'
 *   },
 * });
 */
export function useGetDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetDownloadUrlQuery, GetDownloadUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDownloadUrlQuery, GetDownloadUrlQueryVariables>(GetDownloadUrlDocument, options);
      }
export function useGetDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDownloadUrlQuery, GetDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDownloadUrlQuery, GetDownloadUrlQueryVariables>(GetDownloadUrlDocument, options);
        }
export type GetDownloadUrlQueryHookResult = ReturnType<typeof useGetDownloadUrlQuery>;
export type GetDownloadUrlLazyQueryHookResult = ReturnType<typeof useGetDownloadUrlLazyQuery>;
export type GetDownloadUrlQueryResult = Apollo.QueryResult<GetDownloadUrlQuery, GetDownloadUrlQueryVariables>;